<template>
  <div id="modal-info-body">
    <h2 style="text-align: center">Gerenciar permissões</h2>
    <p>
      A representação da gestão municipal (Secretário(a), Coordenador(a) ou
      Administrador(a) municipal), às vezes deseja ter controle sobre as
      informações que um determinado grupo de usuários poderão acompanhar no
      Monitoramento e Avaliação na APS. Isso pode ser feito marcando ou
      desmarcando as opções em
      <strong>INÍCIO >> Administração >> Gerenciar permissões</strong> e
      confirmando em SALVAR PERMISSÕES.
    </p>
    <br />
    <p>
      Para cada um dos perfis de acesso: AGENTES COMUNITÁRIOS DE SAÚDE, AUX/TEC
      ENFERMAGEM, ENFERMEIRO(A)/MEDICO(A), ODONTÓLOGO(A), RECEPCIONISTA e
      GERENTE/COORDENADOR(A), a gestão municipal pode em
      <strong>INÍCIO >> Administração >> Gerenciar permissões</strong> clicar no
      botão para expandir e marcar para permitir ou desmarcar para o perfil não
      ter mais acesso a alguma página (CARD) específico e depois clicar em
      SALVAR PERMISSÕES.
    </p>
  </div>
</template>
<script>
export default {
  name: 'DocGerenciarPermissoes',
}
</script>
<style scoped>
#modal-info {
  flex: 0 1 33%;
}

#modal-info button {
  width: 35px;
  height: 35px;
  border-radius: 32px;
  display: inline-block;
  background-color: #0fafd7;
  color: #fff;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  margin-top: 0;
  float: right;
}

#modal-info-body h2 {
  font-size: 18px;
  text-align: center;
  font-weight: bold;
}
#modal-info-body .notas-tecnicas {
  text-align: start;
  border-bottom: 1px solid #c1c1c1;
}
#modal-info-body h3 {
  font-size: 14px;
  font-weight: bold;
  margin: 20px 0;
}

#modal-info-body p {
  font-size: 14px;
  text-align: justify;
  margin-bottom: 0;
}

#modal-info-body ul {
  margin: 10px 25px 10px 25px;
  list-style-type: disc;
}

#modal-info-body ul li {
  font-size: 14px;
}

.modal-info-accessibility ul {
  display: inline-flex;
  margin: 10px 0 !important;
  padding: 0;
  gap: 5px;
}

.modal-info-accessibility ul li {
  border: 1px solid;
  list-style-type: none;
  padding: 5px;
  width: 30px;
  text-align: center;
  background-color: #6c757d;
  border-color: #6c757d;
  border-radius: 3px;
}

.modal-info-accessibility ul li a {
  color: #fff;
  font-size: 14px;
}

.modal-info-accessibility ul li a:hover {
  color: #000;
}
</style>
